function explode_jigsaw(jigsaw, duration_ms, callback){
	
	if(jigsaw === undefined){
		return;
	}
	if(duration_ms === undefined){
		duration_ms = 5000;
	} 
	if(typeof duration_ms != 'number'){
		console.error('explode_jigsaw received a non numeric duration_ms');
		return;
	}
	console.log('durations', duration_ms);
	
	var tm_start = Date.now();
	var parts_arr = [];
	
	 $(jigsaw).find('.jig_part').each(function(){
		var $this = $(this);
		
		$this.height( $this.height() );  
		$this.width( $this.width() );  
		$this.css({'max-width': 'none'});
		//$this.addClass('jig_trans_on'); 
		
		parts_arr.push({
			$elem:  $this,
			$dest:  $('#' + this.id + '_after'),
			offset: $this.offset(),
			width:  $this.width(),
			height: $this.height(),
		});
	});
	
	var exploding_interval = setInterval(() => {
		
		var progress = (Date.now() - tm_start) / duration_ms;
		if(progress > 1){
			progress = 1;
		}
		var x = progress * Math.PI / 2;
		
		
		var mod_progress = 1 - Math.pow(Math.cos(x), 8);
		//mod_progress = mod_progress * mod_progress * mod_progress;
		
		for(let orig of parts_arr){
			
			let dest_offset = orig.$dest.offset(); 
			
			let inc_offset_top =  dest_offset.top -  orig.offset.top;
			let inc_offset_left = dest_offset.left - orig.offset.left;
			let inc_height = orig.$dest.height() - orig.height;
			let inc_width =  orig.$dest.width() -  orig.width;
			
			//console.log('progress', progress);
			
			orig.$elem.offset( {
				top: orig.offset.top + inc_offset_top * mod_progress,
				left: orig.offset.left + inc_offset_left * mod_progress,
			} );
			orig.$elem.width( orig.width + inc_width * mod_progress );
			orig.$elem.height( orig.height + inc_height * mod_progress );
		
			if(progress >= 1){
				orig.$elem.fadeOut();
				orig.$dest.animate({opacity: 1});
				
			}
		}
		
		if(progress >= 1){
			clearInterval( exploding_interval );
		
			if(typeof callback === 'function'){
				callback();
			}
		}
		
	}, 20 );  
	
}



function handle_waypoints( el ){
	if(el[0] && el[0].dataset && el[0].dataset.waypoint_on){
		return;
	}
	
	var effect = el.data('effect');
	effect = effect !== undefined ? effect + ' animated' : '';
	
	var offset = el.data('wp_offset');
	offset = offset !== undefined ? offset : 'bottom-in-view';
	
	var callback = el.data('wp_callback');
	callback = typeof( window[ callback ] ) === 'function' ? window[ callback ] : function(){};
	
	if( el.data('childs_default_effect') !== undefined ){
		var def_child_selector = el.data('childs_default_selector') !== undefined ? el.data('childs_default_selector') : ' >*';
		var def_child_effect = el.data('childs_default_effect');
		$(def_child_selector, el).each(function(){
			$(this).data('effect', def_child_effect).attr('data-effect', def_child_effect);
		});
	}
	
	var fn_replay = el.data('wp_callback_replay');
	
	var limit_turnon = is_numeric(fn_replay) ? fn_replay : 1;
	var turned = el.data('turned') ? el.data('turned') : 0;
	//console.log('handling');
	
	var waypoint_delay = el.data('wp_delay');
	waypoint_delay = waypoint_delay !== undefined ? waypoint_delay : 0;//50;
	
	var effect_overwrite = el.data('effect_overwrite');
	effect_overwrite = effect_overwrite !== undefined ? ' '+effect_overwrite : '';
	
	var effect_mode = el.data('effect_mode');
	var effect_fromto = {};
	if(effect_mode === undefined || effect_mode === 'in'){
		effect_fromto = {from: 0, to:1};
	}else{
		effect_fromto = {from: 1, to:0};
	}
	
	// simultaneous || sequential
	var waypoint_childs_runmode = el.data('wp_childs_runmode');
	waypoint_childs_runmode = waypoint_childs_runmode !== undefined ? waypoint_childs_runmode : 'std';
	
	el[0].dataset.waypoint_on = 'true';
	el.waypoint({
		offset: offset,
		handler: function( direction ){
			if(fn_replay === 'always' || turned < limit_turnon){
				el.
					removeClass(effect+effect_overwrite).
					//animate({opacity: effect_fromto.from}).
					addClass( effect ).
					animate({opacity: effect_fromto.to}).
					css({'visibility':'visible'});
				
				el.data('turned', turned++);
				
				setTimeout(function(){
					callback(el, direction);
				}, childs_effects() + waypoint_delay );
				
			}
			
		}
	});
	if(waypoint_childs_runmode !== 'std'){
		el.find('[data-effect]').each(function(){
			this.dataset.waypoint_on = 'true';
		});
	}
	var childs_effects_time = null;
	var childs_effects = function(){
		if(childs_effects_time !== null) return childs_effects_time;
		console.log('init child');
		if(waypoint_childs_runmode !== 'std'){
			var waypoint_childs_delay = el.data('wp_childs_delay');
			waypoint_childs_delay = is_numeric(waypoint_childs_delay) ? parseInt(waypoint_childs_delay) : 0;
			
			var delay = waypoint_childs_delay;
			el.find('[data-effect]').each(function(){
				if(waypoint_childs_runmode === 'sequential')
					delay = delay+waypoint_childs_delay;
					
				var $this = $(this);
				//$this.data('waypoint_on', 'true');
				var effect = $this.data('effect');
				effect = effect !== undefined ? effect + ' animated' : '';
				setTimeout(function(){
					$this.removeClass(effect+effect_overwrite).animate({opacity: effect_fromto.from}).addClass( effect ).animate({opacity: effect_fromto.to}).css({'visibility':'visible'});
				}, delay);
			});
			childs_effects_time = delay+1200;
			return delay+1200;
		}
		return 0;
	};
	
}





function after_load(){
	Waypoint.destroyAll();
	
	$('[data-waypoint_on]').each(function(){
		this.removeAttribute('data-waypoint_on');
	});
	
	$('[data-wp_callback], [data-effect]').each(function(){
		handle_waypoints( $(this) );
	});
	
}

$(document).on('click', 'img[data-magnificable]', function(){
	var elem = this,
		elems = [],
		$current_content = $(this).closest('.content-body'),
		current_content_mg_images = [];
	
	$current_content.find('img[data-magnificable]').each( function(){
		var title = '';
		if( $(this).parent().prop('tagName') === 'FIGURE' && $(this).siblings('figcaption').html() !== undefined) {
			title = $(this).siblings('figcaption').html();
		} else if( $(this).attr('title') !== undefined ) {
			title = $(this).attr('title');
		}
			
		elems.push( this );
		
		current_content_mg_images.push({
			src: $(this).attr('src').replace(/\?thumb=[0-9]+/gi, ''),
			title: title,
			/*sizes: {
				height: $(this)[0].naturalHeight,
				width: $(this)[0].naturalWidth,
			}*/
		});
	});
	
	$.magnificPopup.open({
		items: current_content_mg_images,
		gallery:{
			enabled:true
		},
		zoom: {
			enabled: true,
			duration: 300,
			easing: 'ease-in-out',
			opener: function(openerElement,b) {
				return $current_content.find('[src="'+openerElement.src+'"]').eq(0) || $(elem);
			},
		},
		type: 'image',
	}, elems.indexOf(elem));
});

/**  *** *** *** *** *** *** MAGNIFICABLE IMAGES *** *** *** *** *** *** **/

/**  *** *** *** *** *** ***  PARALLAX TITLE'S  *** *** *** *** *** *** **/

function init_parallax(){
	
	checkMoving = 0;
	isMoving = false;
	
	if( typeof initialized_stellar === 'undefined'){
		initialized_stellar = false;
	} 
	
	$(window).off('scroll.parallax');
	$(window).on('scroll.parallax', function(){
		isMoving = true;
	
		clearTimeout(checkMoving);
		checkMoving = setTimeout(function(){
			isMoving = false;
		}, 400);
	});
	
	var isMobile = /Mobile/.test( navigator.userAgent );

	if(!isMobile && !initialized_stellar){
		//setTimeout(function(){
			initialized_stellar = true;
			$.stellar({
				responsive: true,
				// Hide parallax elements that move outside the viewport
				horizontalScrolling:false,
				hideDistantElements: true,
				positionProperty: 'transform',
				//verticalOffset: 70
			});
		//}, 700);
		//console.log('arrancando parallax!');
	}
	
	
	$('.bg_zone > ul.bgs').each(function(){
		var el = this;
		var el_count = $('li', el).length;
		var bg_zone = $(el).closest('.bg_zone');
		var new_subtitle   = $('li.active', el).data('subtitle');
		var new_font_color = $('li.active', el).data('bg_font_color');
		var new_bg_delay = $('li.active', el).data('bg_delay');
		if(new_bg_delay < 10) new_bg_delay = 4000;
		var this_bg_delay;
		bg_zone.find('.content_subtitle').html(new_subtitle).css({'opacity' : '0.9'});
		bg_zone.find('.title_zone').css({'color' : new_font_color});
	
		if(el_count < 2) return;
		
		function_change_bg = function(){
			clearTimeout(this_bg_delay);
			if( /*$(el).visible(true) &&*/ isMoving === false){
				$(el).closest('.bg_zone').find('.content_subtitle').css({'opacity' : '0'});
				var next = $('li.active', el).removeClass('active').next('li');
				if(next.length >0) next.addClass('active');
				else $('li:first-child', el).addClass('active');
				new_bg_delay = $('li.active', el).data('bg_delay');
				if(new_bg_delay < 10) new_bg_delay = 4000;
				
				setTimeout(function(){
					new_subtitle = $('li.active', el).data('subtitle');
					new_font_color = $('li.active', el).data('bg_font_color');
					
					new_font_color = new_font_color !== undefined ? new_font_color : null;
					bg_zone.find('.content_subtitle').html(new_subtitle).css({'opacity':'0.9'});
					bg_zone.find('.title_zone').css({'color' : new_font_color});
				}, 500);
				//$.stellar('refresh');
			}
			this_bg_delay = setTimeout(function_change_bg, new_bg_delay);
		};
		this_bg_delay = setTimeout(function_change_bg, new_bg_delay);
	});
	/**  *** *** *** *** *** ***  PARALLAX TITLE'S  *** *** *** *** *** *** **/
}